export var Action = /*#__PURE__*/function (Action) {
  Action["FAILED"] = "failed";
  Action["SUCCESS"] = "success";
  return Action;
}({});
export var ActionSubject = /*#__PURE__*/function (ActionSubject) {
  ActionSubject["AUTOCOMPLETE_INITIAL_DATA"] = "autocompleteInitialData";
  ActionSubject["AUTOCOMPLETE_SUGGESTIONS"] = "autocompleteSuggestions";
  return ActionSubject;
}({});
export var ActionSubjectId = /*#__PURE__*/function (ActionSubjectId) {
  return ActionSubjectId;
}({});